// IMPORTANT: THIS FILE IS AUTO GENERATED ON 'npm i' COMMAND ! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v1.11.0-18-g93b994b-dirty",
    "hash": "g93b994b",
    "distance": 18,
    "tag": "v1.11.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.11.0",
        "major": 1,
        "minor": 11,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "1.11.0"
    },
    "suffix": "18-g93b994b-dirty",
    "semverString": "1.11.0+18.g93b994b"
};
/* tslint:enable */
